import {
  AfterViewInit,
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import {
  ConfirmationService,
  ConfirmEventType,
  MessageService
} from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { DateFormetService } from 'src/app/services/dateFormet.service';
import { ImageGeneratorService } from 'src/app/services/image-generator.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';
import { DataTransferService } from '../../cat-edit/data-transfer.service';
import { CatExecutionUploadDocumentsComponent } from '../cat-execution-upload-documents/cat-execution-upload-documents.component';
import { buildOrderFileName } from 'src/app/shared-components/order-file-name.util';
import { getStandardSignatureRect } from 'src/app/shared-components/signature-position.util';

interface Coordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}
interface SignatureCoordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface SignatureConfig {
  method: 'AADHAAR' | 'DSC';
  sign_position: string;
  page: string;
}

interface PositionDetails {
  [key: string]: Coordinates[];
}
@Component({
    selector: 'app-cat-execution-form',
    templateUrl: './cat-execution-form.component.html',
    styleUrls: ['./cat-execution-form.component.scss'],
    standalone: false
})
export class CatExecutionFormComponent implements OnInit, AfterViewInit {
  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('paymentScreen') paymentScreen: TemplateRef<any>;

  positionDetails: any;
  esignTrigger: boolean = false;
  isDraft = false;
  showEsignStep: boolean = false;
  reviewOrderData: any;
  branches: any;
  selectedBranch: any;
  showUploadDocuments: boolean = true;
  showEstampDetails: boolean = false;
  showEsignDetails: boolean = false;
  showConfirmation: boolean = false;
  showSkipped: boolean = false;
  aadhaar_validation: any;
  //-------------------------Step Active --------------------------------------//
  active_product: boolean = false;
  active_eStamp: boolean = false;
  active_eSign: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  uploadDocumentsData: any;
  editTemplateData: any;
  estampData: any;
  esignData: any = [];
  orderConfirmationData: any = { service: 'CAT-Upload' };
  showEsignForm: boolean = true;
  displayBranch!: any;
  branchListDeatils: any = [];
  @ViewChild('uploadData') uploadData!: CatExecutionUploadDocumentsComponent;
  branchId: any;
  @ViewChild('orderDetails') orderDetails!: OrderConfirmationDetailsComponent;
  totalPages: number;
  pageHeight: number[];
  order_reviewer: any;
  userRole: string;
  pageWidth: number[];
  paymentDetails: {
    payeeName: string;
    payeeEmail: string;
    payeeMobileNumber: string;
    payNow: string;
    paymentMethod: string;
  };

  paymentOrderData: any;
  order_payment: boolean = true;
  stateCode: string = '';
  revertedStampData: any;
  isSignerEnable: boolean;
  account_id: any;
  genralFields: { general_fields: any };
  contractType: boolean = false;
  isCatImport: boolean;
  service: string = '';
  otp_validation: boolean = false;

  //------------------------------------------------------------------------------//
  constructor(
    private router: Router,
    private userDashboardService: UserDashboardService,
    private cookieService: CookieService,
    private catUploadService: CatUploadService,
    private messageService: MessageService,
    private dataTransferService: DataTransferService,
    private loader: LoaderService,
    private dateFormetService: DateFormetService,
    private modalService: NgbModal,
    private storageService: StorageService,
    private confirmationService: ConfirmationService,
    private primeng: PrimeNG,
    private route: ActivatedRoute,
    private imageGeneratorService: ImageGeneratorService
  ) {
    this.route.queryParams.subscribe((params) => {
      const nextService = params['service'] || '';
      if (this.service.toUpperCase() !== nextService.toUpperCase()) {
        this.uploadDocumentsData = undefined;
        this.estampData = undefined;
        this.revertedStampData = undefined;
        this.esignData = [];
        this.orderConfirmationData = { service: 'CAT-Upload' };
        if (!params['order_id']) {
          this.catUploadService.clearEstampFormData();
        }
      }
      this.service = nextService;
      if (this.service && this.service.toUpperCase() == 'MULTIPLE-STAMP') {
        this.showUploadDocuments = false;
        this.showEstampDetails = true;
        this.showEsignDetails = false;
        this.showConfirmation = false;
        const refIdConsent = this.storageService.getRefIdConsent() || null;
        if (refIdConsent !== true) {
          // Only auto-generate when Manual Entry toggle is OFF
          this.generateReferenceId();
        }
      } else {
        this.showUploadDocuments = true;
        this.showEstampDetails = false;
        this.showEsignDetails = false;
        this.showConfirmation = false;
      }
    });
    this.loader.show();
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.branches = res['content'];
    });
    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.account_id = this.storageService.getAccountId() || null;
    this.userRole = this.storageService.getRole() || null;
    this.aadhaar_validation = this.storageService.getAdharEdit() || null;
    this.storageService.getSignerValue.subscribe((res) => {
      this.isSignerEnable = res;
    });
    const currentUrl = this.router.url;
    if (currentUrl.includes('cat-import')) {
      this.router.navigate(['/doqfy/bulk-upload/form', 'cat-import']);
      this.isCatImport = true;
    } else {
      this.isCatImport = false;
    }
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
  }
  ngAfterViewInit() {
    // Now the orderDetails component should be available
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    event.preventDefault();
    event.returnValue = false;
  }

  showCustomConfirmation() {
    this.confirmationService.confirm({
      message:
        'Are you sure you want to leave this page? Unsaved changes may be lost.',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-circle',
      accept: () => {
        location.reload(); // Reload manually
      },
      reject: () => {
        console.log('Navigation cancelled');
      },
      acceptLabel: 'Leave',
      rejectLabel: 'Stay',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times'
    });
  }

  //---------------------------------------------------------------------------------//

  changeState(data: any) {
    this.uploadDocumentsData = data;
  }
  onBranchChange(value) {
    this.uploadData.setSelectedBranchValue();
    this.branches.forEach((element) => {
      if (element.name === value) {
        this.branchId = element.id;
      }
    });
  }
  //-------------------Import & export Data from parent to child and vice-versa ----------------------------//

  onproductDetailsChange(data: any): void {
    this.uploadDocumentsData = data;
    this.totalPages = this.uploadDocumentsData.totalPages;
    this.pageHeight = this.uploadDocumentsData.pageHeight;
    this.pageWidth = this.uploadDocumentsData.pageWidth;
    this.genralFields = this.uploadDocumentsData.estampAddinialDetails;
    //this.esignData = data;
    if (this.uploadDocumentsData === undefined) {
      return;
    } else {
      this.goToCatExecutionScreen('estamp');
      this.catUploadService.uploadDocumentsDetails = this.uploadDocumentsData;
      this.branches.forEach((element) => {
        if (element.name === this.uploadDocumentsData.branchName) {
          this.branchId = element.id;
          this.catUploadService.branchId = this.branchId;
        }
      });
    }
  }

  onestampDataChange(data: any): void {
    this.estampData = data;
    this.stateCode = data.selectedState?.state_code;
    this.revertedStampData = data;
    const value = this.estampData.page;
    this.esignData = {
      pdfData: this.dataTransferService.getPdfData(),
      totalPages: this.uploadDocumentsData?.totalPages ?? 0
    };
    this.estampData.branch
      ? (this.selectedBranch = this.estampData.branch)
      : (this.selectedBranch = this.storageService.getBranch() || null);

    // Sync the reference number the user typed into uploadDocumentsData so
    // catUploadPlaceOrder() uses the correct value instead of the stale API-generated one.
    if (data.referenceNumber) {
      this.uploadDocumentsData = {
        ...this.uploadDocumentsData,
        referenceNumber: data.referenceNumber
      };
    }

    this.goToCatExecutionScreen(value);
    if (value === 'esign') {
      this.showEstampDetails = false;
      this.showEsignDetails = true;
      this.esignTrigger = true;
      setTimeout(() => {
        this.esignTrigger = false;
      }, 500);
    }
  }

  onesignDataChange(data: any): void {
    this.order_payment = data.paymentbySigner;
    this.paymentDetails = {
      payeeName: data.payeeName,
      payeeEmail: data.payeeEmail,
      payeeMobileNumber: data.payeeMobileNumber,
      payNow: data.payNowOrLater,
      paymentMethod: data.paymentMethod
    };
    this.esignData = data;

    const value = this.esignData.page;
    if (value === 'confirmation') this.catUploadPlaceOrder();
    if (value === 'estamp') {
      this.goToCatExecutionScreen(value);
      this.estampData = this.revertedStampData;
    }
  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;
  }

  getOrderConfirmation(orderId) {
    this.loader.show();
    let reqParams = {
      order_ids: orderId.toString(),
      detail: 1
    };
    this.catUploadService.getOrderConfirmation(reqParams).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Order Placed!',
            detail: res.message
          });
          this.catUploadService.orderDetails = res.content[0].order;
          this.goToCatExecutionScreen('confirmation');
          if (this.orderDetails) {
            // Ensure orderDetails is defined
            this.orderDetails.getPlacedOrderDetails();
          }
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          for (let i = 0; i < err.error.content.errors.length; i++) {
            this.messageService.add({
              severity: 'error',
              detail: err.error.content.errors[i]
            });
          }
        }
      }
    );
  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  goToCatExecutionScreen(value: string): void {
    console.log('goToCatExecutionScreen called with value:', value); // Debugging line
    this.showUploadDocuments = value === 'uploadDocs';
    this.showEstampDetails = value === 'estamp';
    this.showEsignDetails = value === 'esign';
    this.showConfirmation = value === 'confirmation';
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    // if (value == 'editTemplate')
    //   this.active_product = true;
    // this.active_eStamp = value !== 'editTemplate' && value !== 'estamp';
    // this.active_eSign = value !== 'editTemplate' && value !== 'estamp' && value !== 'esign';
    // this.active_confirm = value === 'confirmation';

    if (value === 'uploadDocs') {
      this.active_product = false;
      this.active_eStamp = false;
      this.active_eSign = false;
      this.active_confirm = false;
    } else {
      this.active_product = true;
      this.active_eStamp = value !== 'estamp';
      this.active_eSign = value !== 'estamp' && value !== 'esign';
      this.active_confirm = value === 'confirmation';
    }
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  generateReferenceId() {
    // If a reference ID was already generated in a previous step, reuse it
    const existing = this.catUploadService.getEstampFormData();
    if (existing?.savedReferenceNumber) {
      this.uploadDocumentsData = {
        ...this.uploadDocumentsData,
        referenceNumber: existing.savedReferenceNumber
      };
      return;
    }

    this.catUploadService.getOrValidateReferenceId().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          const referenceId = res.content.reference_id;
          this.uploadDocumentsData = {
            ...this.uploadDocumentsData,
            referenceNumber: referenceId
          };
          // Persist so estamp-details reuses the same ID
          const existingData = this.catUploadService.getEstampFormData() || {};
          this.catUploadService.setEstampFormData({ ...existingData, savedReferenceNumber: referenceId });
        }
      },
      error: (err) => {
        console.error('Error generating reference ID:', err);
        this.messageService.add({
          severity: 'error',
          detail: err.error?.message || 'Failed to generate reference ID'
        });
      }
    });
  }

  onDraftChanged(isDraftValue: boolean) {
    this.isDraft = isDraftValue;
  }

  async catUploadPlaceOrder() {
    const orderIdFromUrl = this.route.snapshot.queryParamMap.get('order_id');
    this.estampData = this.estampData.map((estamp) => {
      const { page, ...rest } = estamp;
      return rest;
    });

    const base64Doc: string | null =
      this.uploadDocumentsData?.base64Doc ??
      this.uploadDocumentsData?.file ??
      null;

    const service = this.route.snapshot.queryParamMap.get('service');

    let data: any = {
      ...(orderIdFromUrl && { order_id: orderIdFromUrl }),
      document: base64Doc,
      // Store the Reference Number as the file name, not the (possibly very long, joined) list of
      // original upload names — see buildOrderFileName().
      file_name: buildOrderFileName(
        this.uploadDocumentsData?.referenceNumber,
        this.uploadDocumentsData?.fileName ?? null,
      ),
      is_bulk: false,
      is_draft: this.isDraft,
      multi_document: service && service.toUpperCase() === 'MULTIPLE-STAMP',
      order_details: [
        {
          account_id: this.account_id,
          branch_id: this.selectedBranch.id.toString(),
          referance_id: this.uploadDocumentsData.referenceNumber,
          contract_expiry_date: this.uploadDocumentsData?.expiryDate ?? null,
          estamps: this.estampData,
          esigns: {
            party_users: [],
            witness_users: []
          },
          general_fields: this.uploadDocumentsData.estampAddinialDetails ?? {}
        }
      ]
    };
    const contractType = this.storageService.getContractType();
    const contractId = this.storageService.getContractNumber();
    if (contractType) {
      data.contract_type = contractId;
    }
    if (this.esignData.toBeEsigned) {
      this.esignData.addPartyDetailsForm.forEach((element) => {
        let obj = {
          name: element.name,
          email: element.email,
          contact_number: element.contact_number,
          sign_position: element.sign_position,
          method: element.method,
          position_details: element.position_details,
          is_authorised: !!element.is_authorised,
          authorised_for: element.is_authorised ? (element.authorised_for || '') : '',
          pages: element.pages,
          signatory_sequence: element.signatory_sequence,
          send_document: element.send_document,
          send_notification: element.send_notification,
          remark: element.remark,
          reminder: element.reminder,
          schedule_timestamp: this.dateFormetService.formatDateTime(
            element.schedule_timestamp
          ),
          esign_otp: this.otp_validation,
          additional_fields: element.additional_fields,
          aadhaar_digits: (element.method === 'AADHAAR' && this.aadhaar_validation) ? element.aadhaar_digits : '',
          server_side_siganture: element.server_side_siganture,
          estamp_sign: (this.storageService.getStampSignatory() && this.storageService.getDocumentToBeStamped() !== false) ? (element.estamp_sign || false) : false,
          cc_emails: [
            this.esignData.carbon_copy_0,
            this.esignData.carbon_copy_1
          ].filter((email) => !!email),
          sign_mode:
            element.method === 'DSC'
              ? 'USB-Token'
              : element.method === 'ELECTRONIC'
                ? ''
                : element.sign_mode
        };
        data.order_details[0].esigns.party_users.push(obj);
      });

      this.esignData.addWitnessDetailsForm.forEach((element) => {
        let obj = {
          name: element.name,
          email: element.email,
          contact_number: element.contact_number,
          sign_position: element.sign_position,
          method: element.method,
          position_details: element.position_details,
          pages: element.pages,
          signatory_sequence: element.signatory_sequence,
          send_document: element.send_document,
          send_notification: element.send_notification,
          sign_method: element.method,
          remark: element.remark,
          reminder: element.reminder,
          schedule_timestamp: this.dateFormetService.formatDateTime(
            element.schedule_timestamp
          ),
          server_side_siganture: element.server_side_siganture,
          esign_otp: this.otp_validation,
          aadhaar_digits: (element.method === 'AADHAAR' && this.aadhaar_validation) ? element.aadhaar_digits : '',
          sign_mode:
            element.method === 'DSC'
              ? 'USB-Token'
              : element.method === 'ELECTRONIC'
                ? ''
                : element.sign_mode
        };
        data.order_details[0].esigns.witness_users.push(obj);
      });
      data.order_details[0].esigns.party_users.forEach((sign) => {
        if (sign.sign_position === 'DRAG_DROP') {
          sign.pages = Object.keys(sign.position_details).join(',');
          if (contractType) {
            const allCoords: string[] = [];

            Object.keys(sign.position_details).forEach((page) => {
              sign.position_details[page].forEach((coord: any) => {
                const x1 = Math.max(0, coord.x1);
                const y2 = Math.max(0, coord.y2);
                allCoords.push(`${page},${x1},${y2}`);
              });
            });

            sign.position_details = allCoords; // Assign as array, not string
          } else {
            Object.keys(sign.position_details).forEach((page) => {
              sign.position_details[page] = sign.position_details[page].map(
                (coord) => {
                  return {
                    x1: Math.max(0, coord.x1),
                    x2: Math.max(0, coord.x2),
                    y1: Math.max(0, coord.y1),
                    y2: Math.max(0, coord.y2)
                  };
                }
              );
            });
          }
        } else {
          let pagesArray: string[] = [];

          if (typeof sign.pages === 'string') {
            if (this.service.toUpperCase() == 'MULTIPLE-STAMP') {
              this.totalPages = 1;
              this.pageHeight = [841.89];
              this.pageWidth = [595.28];
            }
            const pages = sign.pages.trim().toUpperCase();

            // Handle case where it's "ALL"
            if (pages === 'ALL') {
              pagesArray = Array.from({ length: this.totalPages }, (_, i) =>
                (i + 1).toString()
              ); // Generate array for all pages
            } else {
              // Split specific pages (e.g., "1,2,3")
              pagesArray = pages.split(',').map((page) => page.trim());
            }
          } else if (typeof sign.pages === 'number') {
            // If it's a single page number
            pagesArray = [sign.pages.toString()];
          }

          pagesArray.forEach((page) => {
            const pageIndex = parseInt(page) - 1;
            if (pageIndex >= 0 && pageIndex < this.totalPages) {
              const pageHeight = Math.round(this.pageHeight[pageIndex]);
              const pageWidth = Math.round(this.pageWidth[pageIndex]);

              // e-sign-details already worked out this signature's rect (for this
              // page, or for "ALL"). Use it as is so Pre-Defined/Default land
              // exactly where the drag & drop screen shows them and level with
              // drag & drop signatures. Data that arrives without one gets the
              // same shared calculation.
              const preparedRect =
                sign.position_details?.[page]?.[0] ?? sign.position_details?.['ALL']?.[0];
              if (preparedRect && Number.isFinite(Number(preparedRect.y2))) {
                sign.position_details[page] = [{ ...preparedRect }];
              } else if (
                sign.method === 'ELECTRONIC' ||
                sign.method === 'AADHAAR' ||
                sign.method === 'DSC'
              ) {
                sign.position_details[page] = [
                  getStandardSignatureRect(sign.method, sign.sign_position, pageWidth, pageHeight)
                ];
              }
            }
          });
        }
        if (sign.position_details['ALL']) {
          delete sign.position_details['ALL'];
        }
      });
    }

    if (
      data.order_details[0].estamps.length === 0 &&
      data.order_details[0].esigns.party_users.length === 0 &&
      data.order_details[0].esigns.witness_users.length === 0
    ) {
      this.messageService.add({
        severity: 'error',
        detail: 'Estamp and E-sign details cannot be empty'
      });
      return;
    }

    if (data.document) {
      data.document = await this.imageGeneratorService.mergeAuthorisedFramesIntoPdf(
        data.document,
        data.order_details[0].esigns.party_users,
      );
    }

    if (this.order_reviewer && !contractType && !this.isDraft) {
      const reviewData = { serviceType: 'Contract Upload', details: data };
      this.reviewOrderData = reviewData;
      this.onApproveMethod();
    } else if (
      !contractType &&
      this.isSignerEnable &&
      this.order_payment
    ) {
      this.getPayment(data);
      const reviewData = { serviceType: 'Contract Upload', details: data };
      this.reviewOrderData = reviewData;
    } else {
      this.placeOrderData(data);
    }
  }
  closeModel() {
    this.modalService.dismissAll();
  }

  reviewOrderDataChange(data: any) {
    this.closeModel();
    if (data.path === 'order') {
      this.placeOrderData(data.details);
    }
  }


  onApproveMethod() {
    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  placeOrderData(data: any) {
    const orderId = this.route.snapshot.queryParamMap.get('order_id');

    const isOperationalNesl =
      this.storageService.getContractType() === true &&
      String(this.storageService.getContractNumber()) === '002';

    if (!isOperationalNesl && this.order_payment && this.isSignerEnable) {
      this.getPayment(data);
    } else {
      this.catUploadService.catUploadPlaceOrder(data, orderId).subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.catUploadService.clearFormData();

            // 1. Show the success message immediately
            let successMessage = '';

            if (this.isDraft) {
              successMessage = orderId
                ? 'Draft updated successfully'
                : 'Draft created successfully';
            } else {
              successMessage = res.message || 'Order placed successfully';
            }

            this.messageService.add({
              severity: 'success',
              detail: successMessage
            });

            setTimeout(() => {
              if (this.isDraft) {
                this.router.navigate(['/doqfy/orders/orders-list']);
              } else {
                this.getOrderConfirmation(res.content.order_id);
              }
            }, 1500);
          }
        },
        error: (err) => {
          if (err?.error?.content?.errors) {
            err.error.content.errors.forEach((errMsg) => {
              this.messageService.add({
                severity: 'error',
                detail: errMsg
              });
            });
          } else {
            this.messageService.add({
              severity: 'error',
              detail:
                err?.error?.message ||
                err?.message ||
                'Unable to place the CAT Upload order'
            });
          }
        }
      });
    }
  }

  //------------------------------------Payment Option --------------------------------//

  getPayment(Obj) {
    this.paymentOrderData = {
      orderDetails: Obj,
      payment: this.paymentDetails,
      stateCode: this.stateCode,
      service_type: 'Cat Upload'
    };

    this.modalService
      .open(this.paymentScreen, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  paymentOrderDataChange(event) {
    if (event.status === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Order Placed successfully!',
        detail: event.message
      });
      this.closeModel();
    }
  }
  //-------------------------------------------------------------------------------------//
  handleEstampStep(event: any) {
    if (event.page === 'esign') {
      this.showEsignStep = true;
      this.esignTrigger = true;
      setTimeout(() => (this.esignTrigger = false), 500);
    }
  }
}
